import MKBox from "components/MKBox";
import DefaultNavbar from "sections/DefaultNavbar";
import DefaultFooter from "sections/DefaultFooter";
import HomeHero from "sections/public/HomeHero";
import HomeServices from "sections/public/HomeServices";
import HomeWhyUs from "sections/public/HomeWhyUs";
import HomeCta from "sections/public/HomeCta";
import Counters from "sections/Counters";
import YoutubeVideos from "sections/YoutubeVideos";
import Campaings from "sections/Campaings";
import routes from "routes";
import footerRoutes from "footer.routes";

// The home page used to drop every section inside one floating white Card
// pulled up over the hero, which meant the whole page was a single column of
// undifferentiated content. Sections now alternate ground colour so each one
// reads as its own band.
function Home() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{ type: "internal", route: "/login", label: "LOGIN", color: "info" }}
        sticky
      />

      <HomeHero />
      <HomeServices />

      <MKBox component="section" py={{ xs: 2, md: 4 }}>
        <Counters />
      </MKBox>

      <HomeWhyUs />
      <YoutubeVideos />
      <Campaings />
      <HomeCta />

      <MKBox pt={6} px={1}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Home;
